import { render } from "./PageFailed.vue?vue&type=template&id=1bc38154&scoped=true"
import script from "./PageFailed.vue?vue&type=script&lang=js"
export * from "./PageFailed.vue?vue&type=script&lang=js"

import "./PageFailed.vue?vue&type=style&index=0&id=1bc38154&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc38154"]])

export default __exports__